import actionTypes from "./actions/actionTypes";

const {
  REQUEST_REPORTS,
  RECIEVE_REPORTS,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS,
} = actionTypes;

const problemReportReducer = (
  state = {
    isFetchingList: false,
    reports: [],
    hasServerError: false,
    errors: {},
    success: false,
  },
  action
) => {
  switch (action.type) {
    case REQUEST_REPORTS:
      return Object.assign({}, state, {
        isFetchingList: true,
        hasServerError: false,
        errors: {},
        success: false,
      });
    case RECIEVE_REPORTS:
      return Object.assign({}, state, {
        isFetchingList: false,
        reports: action.reports,
        success: true,
      });
    case CLEAR_ERRORS: 
      return Object.assign({}, state, {
        hasServerError: false,
        errors: {},
        success: false,
      })
    case SERVER_ERROR_OCURED: 
      return Object.assign({}, state, {
        hasServerError: true,
        errors: action.errors,
        success: false
      })
    default:
      return state;
  }
};

export default problemReportReducer;





// WEBPACK FOOTER //
// src/routes/ProblemReports/reducer.js